import React from "react";
import {
  Box,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { AutoStories, Insights, Quiz, School } from "@mui/icons-material";
import { signupPurposes } from "./signupPurpose";

const icons = {
  marking: AutoStories,
  performance: Insights,
  quiz: Quiz,
  school: School,
};

export function SignupPurposeCards({ value, onChange, disabled = false }) {
  return (
    <RadioGroup
      aria-label="What would you most like help with?"
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        gap: 2,
      }}
    >
      {signupPurposes.map((option) => {
        const Icon = icons[option.icon];
        return (
          <FormControlLabel
            key={option.value}
            value={option.value}
            disabled={disabled}
            control={<Radio size="small" />}
            sx={{
              m: 0,
              p: 2,
              border: "2px solid",
              borderRadius: 2,
              alignItems: "flex-start",
              borderColor: value === option.value ? "primary.main" : "divider",
              bgcolor:
                value === option.value ? "action.selected" : "background.paper",
              "&:focus-within": {
                outline: "2px solid",
                outlineColor: "primary.main",
                outlineOffset: 2,
              },
            }}
            label={
              <Stack spacing={1}>
                <Box>
                  <Icon color="primary" />
                </Box>
                <Typography fontWeight={600}>{option.title}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {option.description}
                </Typography>
              </Stack>
            }
          />
        );
      })}
    </RadioGroup>
  );
}
